function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 24,
  height: 24,
  rx: 4,
  fill: "#FB3844"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0003 10.3332C10.5276 10.3332 9.33366 11.5271 9.33366 12.9998C9.33366 14.4726 10.5276 15.6665 12.0003 15.6665C13.4731 15.6665 14.667 14.4726 14.667 12.9998C14.667 11.5271 13.4731 10.3332 12.0003 10.3332ZM10.667 12.9998C10.667 12.2635 11.2639 11.6665 12.0003 11.6665C12.7367 11.6665 13.3337 12.2635 13.3337 12.9998C13.3337 13.7362 12.7367 14.3332 12.0003 14.3332C11.2639 14.3332 10.667 13.7362 10.667 12.9998Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0003 5.6665C12.3685 5.6665 12.667 5.96498 12.667 6.33317V7.03646C15.4481 7.34389 17.6563 9.55209 17.9637 12.3332H18.667C19.0352 12.3332 19.3337 12.6316 19.3337 12.9998C19.3337 13.368 19.0352 13.6665 18.667 13.6665H17.9637C17.6563 16.4476 15.4481 18.6558 12.667 18.9632V19.6665C12.667 20.0347 12.3685 20.3332 12.0003 20.3332C11.6321 20.3332 11.3337 20.0347 11.3337 19.6665V18.9632C8.55258 18.6558 6.34438 16.4476 6.03694 13.6665H5.33366C4.96547 13.6665 4.66699 13.368 4.66699 12.9998C4.66699 12.6316 4.96547 12.3332 5.33366 12.3332H6.03694C6.34438 9.55209 8.55258 7.34389 11.3337 7.03646V6.33317C11.3337 5.96498 11.6321 5.6665 12.0003 5.6665ZM7.33366 12.9998C7.33366 15.5772 9.423 17.6665 12.0003 17.6665C14.5777 17.6665 16.667 15.5772 16.667 12.9998C16.667 10.4225 14.5777 8.33317 12.0003 8.33317C9.423 8.33317 7.33366 10.4225 7.33366 12.9998Z",
  fill: "white"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4c3e5598.svg";
export { ForwardRef as ReactComponent };